import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

import { PageProps } from '@/types/PageProps';

import DefaultRouteTabs from '@/components/_common/DefaultRouteTabs';
import BillToReceiveMigrationConsultList from '@/components/Financial/BillToReceive/BillToReceiveMigrationConsultList';

export default function ReleasesBillToReceiveMigrationConsultPage({
  route,
}: PageProps) {
  const intl = useIntl();

  return (
    <>
      <DefaultRouteTabs route={route.parent} permissions={route.permissions}>
        <Helmet title={intl.formatMessage({ id: route.name })} />

        <BillToReceiveMigrationConsultList />
      </DefaultRouteTabs>
    </>
  );
}
